import * as React from "react";
import { Query } from "react-apollo";
import { match } from "react-router-dom";

import { UserQuery, userQuery } from "../graphql/user";
import SendChallengeModal from "../challenge/SendChallengeModal";
import ChallengeCard from "../challenge/ChallengeCard";
import { Trigger } from "../common";
import { Button, Card } from "../semantic-ui";

type Props = {
  match: match<{ id: string }>;
};

const UserPage = ({ match }: Props) => (
  <Query<UserQuery> query={userQuery} variables={{ id: match.params.id }}>
    {({ data, loading, error, refetch }) => {
      if (loading) return <div>Loading...</div>;
      if (error || !data) {
        return (
          <div>
            <strong>Error:</strong> {error!.message}
          </div>
        );
      }
      const challengeCard =
        data.me && data.me.incomingChallenges.nodes.length > 0 ? (
          <ChallengeCard
            challenge={data.me.incomingChallenges.nodes[0]}
            onChange={() => refetch()}
          />
        ) : data.me && data.me.outgoingChallenges.nodes.length > 0 ? (
          <ChallengeCard
            challenge={data.me.outgoingChallenges.nodes[0]}
            onChange={() => refetch()}
          />
        ) : data.me ? (
          <Trigger
            component={Card}
            control={(show) => (
              <>
                <Card.Content>
                  <Card.Header>
                    Send a challenge to {data.user.name}
                  </Card.Header>
                </Card.Content>
                <Card.Content extra>
                  <Button fluid basic primary onClick={show}>
                    Send challenge
                  </Button>
                </Card.Content>
              </>
            )}
            modal={(isShown, hide) => (
              <SendChallengeModal
                show={isShown}
                onHide={hide}
                recipient={data.user}
              />
            )}
          />
        ) : null;
      return (
        <div>
          <h1>{data.user.name}</h1>
          <Card.Group itemsPerRow={3} stackable>
            {challengeCard}
          </Card.Group>
        </div>
      );
    }}
  </Query>
);

export default UserPage;
